import axios, {AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig} from 'axios';
import {UrlConfig} from "../../config/url-config.ts";
import {LocalStorageKey} from "../../../types/IGameStat.ts";

// 定义通用的响应结构
export interface ApiResponse<T> {
    data: T;
    code: number;
    message: string,
    showType: number, // 返回的信息提示类型
}

// 创建Axios实例并配置基础信息
// 'Cache-Control': 'no-cache, no-store, must-revalidate'
// 配置这个策略是因为安卓端的cgtn app状态更新有问题，会不更新，这样设置之后就正常了
export const instance = axios.create({
    // 配置基准URL
    baseURL: UrlConfig.BASE_API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate'
    }
});

// 配置请求拦截器（可选）
instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    // 从本地获取token，然后放到请求的header中
    const token = localStorage.getItem(LocalStorageKey.TOKEN);
    if (token) {
        // config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['Authorization'] = token;
    }
    return config;
});

// 配置响应拦截器（可选）
instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: unknown) => Promise.reject(error)
);

// 定义一个通用的后端请求服务类
class NetworkService {

    public async get<T>(url: string, params?: object): Promise<ApiResponse<T>> {

        const response = await instance.get(url, {params});
        return this.handleResponse(response);

    }

    public async post<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {

        const response = await instance.post(url, data, config);
        return this.handleResponse(response);
    }

    // 通用的请求处理方法
    // private async request<T>(config: AxiosRequestConfig): Promise<ApiResponse<T | null>> {
    //     try {
    //         const response = await instance.request(config);
    //         return this.handleResponse(response);
    //     } catch (error) {
    //         return this.handleError(error);
    //     }
    // }

    // 处理响应数据
    private handleResponse<T>(response: AxiosResponse): ApiResponse<T> {
        if (response.data['showType'] === 9) {
            // 清除本地token，跳转登录页面
            localStorage.removeItem('token');
            // 直接刷新页面
            window.location.reload();
        }
        return {
            data: response.data['data'],
            code: response.data['code'],
            showType: response.data['showType'],
            message: response.data['message'],
        };
    }
}

export default NetworkService;